import { hasUserFlag, setUserFlag } from "./userFlag";

/**
 * "I Understand" on the signup Welcome/KYC-consent modal. Stored per user so
 * the modal shows once per account, not on every page that mounts it or on
 * every revisit of the NIN step. Frontend-only record, not a server-side
 * consent audit.
 */
const FLAG = "welcome_consent_ack";

export const acknowledgeWelcomeConsent = (userId?: string | number | null) =>
  setUserFlag(FLAG, userId);

export const isWelcomeConsentAcknowledged = (userId?: string | number | null) =>
  hasUserFlag(FLAG, userId);
